module.exports = __webpack_public_path__ + "img/topic-hero.137d34dd.jpg";